export default __webpack_public_path__ + "adobe-character.7cb08a09.png";